import PropTypes from 'prop-types';
import React from 'react';
import { getAnnouncements } from './registry';

const ScannersAnnouncements = ({ isLocalStorageLoaded }) => {
  if (!isLocalStorageLoaded) {
    return null;
  }

  return getAnnouncements().map((Component, index) => (
    <Component key={index} />
  ));
};

ScannersAnnouncements.propTypes = {
  isLocalStorageLoaded: PropTypes.bool
};

export default ScannersAnnouncements;
